import React, { Component,useState,useEffect } from 'react';
import axios from "axios";
import { ReactiveBase, MultiList, ResultCard, DataSearch, RatingsFilter, ReactiveList, SelectedFilters, ResultList } from '@appbaseio/reactivesearch';
import DisplayStarIcons from '../Utils/DisplayStarIcons';
import StarRatings from 'react-star-ratings';
import profile1 from "../assets/images/profile1.jpg"
import Button from 'react-bootstrap/Button';
import { Link, withRouter,NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import queryString from 'query-string';
import profilePic from '../assets/images/profile1.jpg'
import b1 from "../assets/images/b1.jpg"
import { PData } from "../assets/productData";
import { getBusiness } from '../Services/business.service';
console.log(PData);

const components = {

  selectedFilters: {showClearAll: true,clearAllLabel: "Clear filters"},
  reactiveListProps: {
    reactiveListProps: {
     componentId: 'queryResult',
     dataField: 'company.search',
     className: 'result-list-container',
     from: 0,
     size: 5,
     onData: item => 
        <ReactiveList.ResultListWrapper>
          {/* {console.log('items that are shown in :',item)} */}
        <ResultList key={item._id}>                        
        <ResultList.Content className="resultList-description">
            <ResultList.Title>{item.company}</ResultList.Title>
            <ResultList.Description>
            <div>
                <p className="show2lineOnly">Address: {item.address}</p>
                <span key="phone" className="show1lineOnly" >Phone: {item.phone}</span>
                <div> Current Rating : {DisplayStarIcons(item.rating)}</div>
                <div className="tag">{item.categories}</div>
                {/* className="show2lineOnly" */}
            </div>
            </ResultList.Description>                            
        </ResultList.Content>
        <div className="write-review">   
          <Link className="btn buttons btn-dark" to={`/rate/${item._id}`}>Write Review</Link>                       
        </div>
        </ResultList>
        </ReactiveList.ResultListWrapper>,
     defaultQuery: () => ({
       query: {
         exists: {
           field: 'company',
         },
       },
     }),
     react: {
       and: ['searchTerm', 'company-types-list'],
     },
   },     
 }
  
}

const mapStateToProps = state => {
  return { url: state.url };
};

class WriteReview extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      isClicked:null,
      searchTerm: "",
      isClicked: false,
      message: "🔬Show Filters",
      listView:true,
      listData:[]
      };      
    this.defaultQuery = this.defaultQuery.bind(this);  
    //this.rateCompany = this.rateCompany.bind(this);
  }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search);
    if (values !== "") {     
      this.setState({
        searchTerm:values.searchTerm
    });
    
  }}
 

  setPlaceHolder() {
    if (this.state.searchTerm) {
      return this.state.searchTerm;
    }
    else
      return "Search for company ...";
  }

  defaultQuery() {
    if(this.state.searchTerm){
    return {
      "query": {
        "match": { "company": this.state.searchTerm }
      }
    };
  }
  else {
    return {
      "query": {
        "match_all": {}
      }
    };  
  }}

  updateSearchTerm(value) {
    this.setState({
      searchTerm: value,
    });
  }

 /*  rateCompany(value) {
    this.props.history.push("/rate-company/:" + value);
  } */

  handleClick() {
    this.setState({
      isClicked: !this.state.isClicked,
      message: this.state.isClicked ? "🔬 Show Filters" : "Hide Filters"
    });
  }

  render() {
   
    return (     

        <div className="writeReviewPage mt-70">
          <ReactiveBase
            app="rate-review-repeat"
            credentials="J2VtlWoNW:86694908-5edd-48c4-9d89-1ef5081148d8"
          >
          <div className="navbar jc-center">
            <div className="my-3">
              <h2 className="themeColor2 fs-1-5rem-sm"> Find Reviews of Business</h2>
            </div>
              <div className="search-container">
                  <DataSearch componentId="searchTerm"            
                      dataField={["company", "company.search"]}                      
                      className="search-bar"  
                      queryFormat="and"                   
                      URLParams={true}                       
                      defaultValue={this.state.searchTerm}  
                      placeholder={this.setPlaceHolder()}
                      onValueSelected={(value) => {this.updateSearchTerm(value)}}                     
                  >      
                  </DataSearch> 
              </div>
          </div>
          <div className="container">
          <div className="sub-container">
        <div  className={
                this.state.isClicked
                  ? "result-container-optional"
                  : "result-container"
              } >
            
            <SelectedFilters {...components.selectedFilters} />
            <div className="reviewPage-List-gridIcon">
            <i class="fa fa-list" aria-hidden="true" onClick={()=>this.setState({listView:true})}></i>
            <i class="fa fa-th border border-2 border-success" aria-hidden="true" onClick={()=>this.setState({listView:false})}></i>
            </div>

                 {this.state.listView
                      ?
              <ReactiveList
                
                componentId="queryResult"
                dataField="company"
                Loader="Loading..."
                noResults="No results were found..."
                innerClass={{
                  title: "result-title",
                  listItem: "result-item",
                  list: "list-container",
                  sortOptions: "sort-options",
                  resultStats: "result-stats",
                  resultsInfo: "result-list-info"
                }}

                react={{
                  and: [
                    "searchTerm",
                    "ratings",
                    "company-types-list"
                   
                  ]
                }}  
                defaultQuery={this.defaultQuery}
                
                sortOptions={[
                  {
                    dataField: "rating.keyword",
                    sortBy: "desc",
                    label: "Sort by Rating(High to Low)"
                  },
                  {
                    dataField: "rating.keyword",
                    sortBy: "asc",
                    label: "Sort by Rating(Low to High)"
                  },
                  {
                    dataField: "company.keyword",
                    sortBy: "asc",
                    label: "Sort by Company Name(A to Z)"
                  }   
                ]}            
                from={0}
                size={5}
                className="most-review mt-0 mb-0"
                
                
                renderItem={
                  (item) => (
                  <ReactiveList.ResultListWrapper>         
                        <ResultList key={item._id}>                        
                        <div className="reviewPageListImg">
                          <img src={profilePic} alt="profilePic" />
                          {console.log('filter ',item)}
                        </div>
                          <ResultList.Content className="resultList-description">
                              <ResultList.Title>{item.company}</ResultList.Title>
                              <ResultList.Description>
                              <div>
                                  <p className="show2lineOnly">Address: {item.address}</p>
                                  <span key="phone" className="show1lineOnly">Phone: {item.phone}</span>
                                  <div> Current Rating : {DisplayStarIcons(item.rating)}</div>
                                  <div className="tag">{item.categories}</div>
                                  {/* className="show2lineOnly */}
                              </div>
                              </ResultList.Description>                            
                          </ResultList.Content>
                          <div className="write-review">  
                          <Link className="btn buttons reviewPage-WriteBtn" to={{pathname:`/rate-company/${item._id}`, state: {companyName: item.company}}}>Write Review</Link>                                             
                          {/* <Button className="btn buttons btn-dark"  onClick={this.rateCompany(item._id)} >Write Review</Button>                        */}
                          </div>
                          </ResultList>
                      
                      
                    </ReactiveList.ResultListWrapper>
                )}
                pagination={true}
                react={{
                    and: [            
                    "searchTerm",
                    "company-types-list",
                    "ratings"
                    ]
                }}
                
                renderError={error => (
                    <div>
                    Something went wrong with ResultList!
                    <br />
                    Error details
                    <br />
                    {error}
                    </div>
                )}
            />    
               :
                
                  <GridCard />
                }    
              </div>
              <button className="toggle-button" onClick={this.handleClick.bind(this)} >
              {this.state.message}
            </button>
        </div>
        </div>
       
          </ReactiveBase>    
        
      </div>

        
      
    );
  }
}

const GridCard=(props)=>{
  const [post,setPost]=useState([]);
  const [loader,setLoader]=useState(false);
  const [currentPage,setCurrentPage]=useState(1);
  const [postPerPage,setPostPerPage]=useState(12);
  const [realBusinesses,setrealBusinesses] = useState();
  useEffect(() => {
    const fetchPost=async () =>{
      setLoader(true)
      const res= await axios.get('https://jsonplaceholder.typicode.com/posts');
      getBusiness().then((res)=>{
        setrealBusinesses(res);
        console.log('business Array is',res);
        // for (let i=0;i<res.length-1;i++)
        // {
        //     for(let j=i+1;j<res.length;j++){
        //         if(res[i].businessCount<res[j].businessCount){
        //             let temp = res[j];
        //             res[j]=res[i];
        //             res[i]=temp;
        //         }
        //     }
        // }
        //console.log('response array after sorting is',res);
        // setSortedBusiness(res);

    });
      setPost(res.data);
      setLoader(false)
    }
    fetchPost()
  }, [])

  // get ccurrent post
    const indexOfLastPost = currentPage * postPerPage;
    const indexOfFirstPost = indexOfLastPost - postPerPage;
    const currentPost = post.slice(indexOfFirstPost,indexOfLastPost)

    //change page
    const paginate = (pageNumbers) => setCurrentPage(pageNumbers)
  if(loader){
    return <h2 className="mt-5">loading</h2>
  }
  return(
    <>
            <div className="row most-review mb-4">
                  {
                    realBusinesses&&realBusinesses.map((item,index)=>(

                      <div className="col-lg-4 col-md-6 mb-3" key={index}>    
                        <NavLink className="businessCard" to="/description">
                        <div className="imgDiv">
                          {console.log(item)}
                            <img src={item.coverPhotoURL} alt="" />
                            <div className="textDiv">
                                <h4 className="mb-3">{item.name}</h4>
                                <div><address>{item.address}{item.city}</address></div>
                                <div className="phone"><i class="fa fa-phone mr-1" aria-hidden="true"></i>{item.phoneNumber}</div>
                            </div>
                        </div>
                        <div className="ratingDiv">
                            <div className="">
                            <StarRatings
                            rating={item.businessCount%5}
                            starDimension="18px"
                            starSpacing="1px"
                            numberOfStars={5}
                            starRatedColor="orange"
                        />
                            </div>
                            <div className="profileDiv"><img src={item.logoURL} alt="logo" /></div>
                        </div>
                        </NavLink>
                      </div>
                      ))
                  // currentPost.map((item)=>(

                  //   <div className="col-lg-4 col-md-6 mb-3">    
                  //     <NavLink className="businessCard" to="/description">
                  //     <div className="imgDiv">
                  //         <img src={b1} alt="" />
                  //         <div className="textDiv">
                  //             <h4 className="mb-3">{item.title}</h4>
                  //             <div><address>{item.body}</address></div>
                  //             <div className="phone"><i class="fa fa-phone mr-1" aria-hidden="true"></i>9212345566</div>
                  //         </div>
                  //     </div>
                  //     <div className="ratingDiv">
                  //         <div className="">
                  //         <StarRatings
                  //         rating={4.2}
                  //         starDimension="18px"
                  //         starSpacing="1px"
                  //         numberOfStars={5}
                  //         starRatedColor="orange"
                  //     />
                  //         </div>
                  //         <div className="profileDiv"><img src={profile1} alt="logo" /></div>
                  //     </div>
                  //     </NavLink>
                  //   </div>
                 // ))
                  }
            </div>

            <Pagination postPerPage={postPerPage} totalPosts={post.length} paginate={paginate} />
    </>
  )
}


 const Pagination = ({ postPerPage, totalPosts, paginate }) => {
   const pageNumbers = [];
   for(let i=1;i<=Math.ceil(totalPosts / postPerPage);i++){
     pageNumbers.push(i);
   }
  return (
    <>
      <nav>
        <ul className="pagination jc-center mb-5">
          {pageNumbers.map((number =>(
            <li key={number} className="page-item">
              <a onClick={()=> paginate(number)}  className="page-link">
                {number}
              </a>

            </li>
          )))}
        </ul>
      </nav>
    </>
  )
}




export default WriteReview;
